import React, { useEffect, useState } from "react";
import { ISelectOption } from "@/components/YhFormBox/Types";
import { YHDrawer } from "@/components/YhDrawer";
import { useSummaryModel } from "./summaryModel";
import { message, Select, TreeSelect, Table } from "antd";
import { accountService, creditFlagDs } from "../../../AccountService";
import { Form, Button, Space } from 'antd';
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { useAccountModel } from "../detail/account/accountModel";
import { ColumnsType } from "antd/lib/table";
import { ICustomerAccountSummary, IFMSInitAccountForm, ISCMInitCustomer } from "../../../AccountTypes";
import { CreditFlagEnum, AccountTypeEnum } from "@/types/FmsEnums";
import { useGlobalModel } from "@/model/globalModel";
import { fmsDictService } from "@/views/account/dictService";
import { DictCodeEnmu } from "@/types/VrmSaDictEnums";


export const InitAccountDrawer = () => {
	const [form] = Form.useForm();

	const { initAccountVisible, setInitAccountVisible, loadData, selectedRowKeys, setSelectedRowKeys } = useSummaryModel();
	const { accountTypeDs, setAccountType } = useAccountModel();

	const { shopAndOrg: { shopCode, shopName }, appDs, beShopDs } = useGlobalModel();

	useEffect(() => {
		if (selectedRowKeys.length === 0) {
			onCancel();
		}
	}, [selectedRowKeys])

	useEffect(() => {
		if (initAccountVisible) {
			fmsDictService.dictItemDs(DictCodeEnmu.ACCOUNT_TYPE).then(ds => setAccountType(ds))
		} else {
			form.resetFields();
		}
	}, [initAccountVisible]);

	//初始话账户脚本
	// const loadDataAl = async (pagNum: number) => {
	// 	try {
	// 		const searchParams = {
	// 			...defaultMdCmParam,
	// 			shopCode,
	// 			page: {
	// 				pageSize: 10,
	// 				pageNum: pagNum
	// 			}
	// 		}
	// 		let { retData } = await accountShopService.customerSummaryPage(searchParams);
	// 		const { records, ...pg } = retData;
	// 		if (records && records.length > 0) {
	// 			let mdCustomers: ISCMInitCustomer[] = records.map(item => ({
	// 				code: item.code ?? "",
	// 				name: item.name ?? ""
	// 			}));
	// 			let data: IFMSInitAccountForm = {
	// 				"type": "0",
	// 				"fmsAccounts": [
	// 					{
	// 						"branch": "scm",
	// 						"accountTypeCode": "account-type.credit",
	// 						"accountTypeName": "授信账户",
	// 						"shopCode": "SHOP-M-00000001",
	// 						"shopName": "潍柴中心库",
	// 						"beCode": "bentity.bj-ouhao",
	// 						"beName": "北京欧豪汽车贸易有限公司",
	// 						"creditFlag": 1
	// 					},
	// 					{
	// 						"creditFlag": 0,
	// 						"branch": "scm",
	// 						"accountTypeCode": "account-type.cash",
	// 						"accountTypeName": "现金账户",
	// 						"beCode": "bentity.bj-ouhao",
	// 						"beName": "北京欧豪汽车贸易有限公司",
	// 						"shopCode": "SHOP-M-00000001",
	// 						"shopName": "潍柴中心库"
	// 					},
	// 					{
	// 						"creditFlag": 0,
	// 						"branch": "scm",
	// 						"accountTypeCode": "account-type.rebate",
	// 						"accountTypeName": "返利账户",
	// 						"beCode": "bentity.bj-ouhao",
	// 						"beName": "北京欧豪汽车贸易有限公司",
	// 						"shopCode": "SHOP-M-00000001",
	// 						"shopName": "潍柴中心库"
	// 					}
	// 				],
	// 				mdCustomers
	// 			};
	// 			await accountService.initAccount(data).then(res => {
	// 				if (res) {
	// 					console.log(`初始化成功，第${pagNum}页,`)
	// 				}
	// 			});
	// 		} else {
	// 			console.log("没有符合条件的数据")
	// 		}
	// 	} catch (errInfo) {
	// 		console.log('数据保存失败', errInfo);
	// 	}
	// }

	const onOk = async () => {
		form.validateFields().then(res => {
			let result = res as IFMSInitAccountForm;
			// let accountType = result?.fmsAccounts?.map(item => item.accountTypeCode); //判断选中的时候有重读的账户类型
			// if (accountType.length !== new Set(accountType).size) {
			// 	message.warning("请不要选择有重复的账户类型");
			// 	return;
			// }
			let mdCustomers: ISCMInitCustomer[] = selectedRowKeys.map(item => ({
				code: item.code ?? "",
				name: item.name ?? ""
			}))
			accountService.initAccount({
				type: "0",
				fmsAccounts: result?.fmsAccounts ?? [],
				mdCustomers,
			}).then(res => {
				if (res) {
					onCancel();
					setSelectedRowKeys([]);
					message.success(res.retData ?? "初始化成功")
				}
			})
		})
	}

	const onCancel = () => {
		setInitAccountVisible(false);
	}

	//设置对应字段的名称
	const setFormFmsAccounts = (index: number, fieldName: string, fieldVal: ISelectOption) => {
		let fromVal: IFMSInitAccountForm = form.getFieldsValue();
		let newVal = fromVal.fmsAccounts[index];

		//判断当 更改授信类型时， 重置账户类型重新选择
		if (fieldName === "creditFlag") {
			fromVal.fmsAccounts.splice(index, 1, { ...newVal, ["accountTypeCode"]: undefined });
		} else {
			fromVal.fmsAccounts.splice(index, 1, { ...newVal, [fieldName]: fieldVal.label });
		}
		form.setFieldsValue(fromVal);
	}

	const columns: ColumnsType<ICustomerAccountSummary> = [
		{
			title: '序号',
			fixed: "left",
			width: 66,
			align: "center",
			render: (t, r, i) => i + 1
		},
		{
			align: "center",
			title: '客户名称',
			dataIndex: 'name',
		},
		{
			align: "center",
			title: '客户编码',
			dataIndex: 'code',
		},
		{
			title: '操作',
			width: 80,
			align: "center",
			render: (text, record) => <MinusCircleOutlined
				className="dynamic-delete-button"
				onClick={() => {
					let filterData = selectedRowKeys.filter(item => item.key !== record.key);
					setSelectedRowKeys(filterData);
				}}
			/>
		}
	]
	return (
		<YHDrawer
			{...{
				title: "账户初始化",
				width: 900,
				visible: initAccountVisible,
				closable: true,
				onOk,
				onCancel,
				showFooter: true
			}}
		>
			<Form form={form} autoComplete="off" initialValues={{
				"fmsAccounts": [{
					branch: undefined,
					accountTypeCode: undefined,
					accountTypeName: undefined,
					shopCode,
					shopName,
					beCode: undefined,
					beName: undefined,
					creditFlag: CreditFlagEnum.CREDIT
				}]
			}}>
				<Form.List name="fmsAccounts">
					{(fields, { add, remove }) => {
						return (
							<>
								{fields.map((field, index) => (
									<Space key={field.key} style={{ display: 'flex' }} align="baseline">
										{/* 分支 */}
										<Form.Item
											{...field}
											name={[field.name, 'branch']}
											rules={[{ required: true, message: '请选择分支' }]}
										>
											<Select
												style={{ width: 160 }}
												placeholder="系统分支"
												options={appDs}
											/>
										</Form.Item>

										{/* 授信类型 */}
										<Form.Item
											{...field}
											name={[field.name, 'creditFlag']}
											rules={[{ required: true, message: '请选择授信类型' }]}
										>
											<Select
												style={{ width: 160 }}
												placeholder="授信类型"
												options={creditFlagDs()}
												onChange={(value, option) => {
													if (option) {
														setFormFmsAccounts(index, "creditFlag", option as ISelectOption);
													}
												}}
											/>
										</Form.Item>

										{/* 账户类型 */}
										<Form.Item
											{...field}
											name={[field.name, 'accountTypeCode']}
											rules={[{ required: true, message: '请选择账户类型' }]}
										>
											<Select
												style={{ width: 160 }}
												placeholder="账户类型"
												options={(() => {
													const fromVal: IFMSInitAccountForm = form.getFieldsValue();
													const newVal = fromVal.fmsAccounts?.[index]?.creditFlag ?? 1;
													return accountTypeDs.filter(
														(item) =>
															newVal === 1
																? item.type === DictCodeEnmu.SETTLE_TYPE_CREDIT
																: newVal === 0
																	? item.type === DictCodeEnmu.SETTLE_TYPE_CASH
																	: item.type === DictCodeEnmu.SETTLE_TYPE_BALANCE
													);
												})()}
												onChange={(value, option) => {
													if (option) {
														setFormFmsAccounts(index, "accountTypeName", option as ISelectOption);
													}
												}}
											/>
										</Form.Item>

										{/* 账户实体 */}
										<Form.Item
											{...field}
											name={[field.name, 'beCode']}
											rules={[{ required: true, message: '请选择账户实体' }]}
										>
											<Select
												style={{ width: 160 }}
												placeholder="账户实体"
												options={beShopDs}
												onChange={(value, option) => {
													if (option) {
														setFormFmsAccounts(index, "beName", option as ISelectOption);
													}
												}}
											/>
										</Form.Item>

										{/* 组织机构 */}
										<Form.Item
											{...field}
											name={[field.name, 'shopCode']}
											rules={[{ required: true, message: '请选择组织机构' }]}
										>
											<Select
												style={{ width: 160 }}
												placeholder="从属站点"
												options={[{ label: shopName, value: shopCode }]}
												onChange={(value, option) => {
													if (option) {
														setFormFmsAccounts(index, "shopName", option as ISelectOption);
													}
												}}
											/>
										</Form.Item>

										{/* 删除按钮 */}
										{fields.length > 1 ? (
											<MinusCircleOutlined
												className="dynamic-delete-button"
												onClick={() => remove(field.name)}
											/>
										) : null}
									</Space>
								))}

								{/* 增加按钮 */}
								<Form.Item>
									<Button
										type="dashed"
										onClick={() => add({ creditFlag: CreditFlagEnum.CREDIT })}
										block
										icon={<PlusOutlined />}
									>
										增加
									</Button>
								</Form.Item>
							</>
						);
					}}
				</Form.List>

			</Form>
			<Table
				bordered
				columns={columns}
				dataSource={selectedRowKeys}
				pagination={false}
			/>
		</YHDrawer>
	)
}
